(function () {
	'use strict';

	angular.module('app.core')
	.controller('priceBreakAnalysis', priceBreakAnalysis); 



	priceBreakAnalysis.$inject = ['$scope','$timeout', '$experiments', 'priceBreakAnalysisService', 'percentageFormatService', 'numberFormatService', 'currencyFormatService', 'integerFormatService', 'drilldownFunctionsService'];

	function priceBreakAnalysis($scope, $timeout, $experiments, priceBreakAnalysisService,  percentageFormatService, 
			numberFormatService, currencyFormatService, integerFormatService, drilldownFunctionsService) {
		// Set navigation properties
		var vm = this;


		$scope.getWeeklyRequirementReportDrilldownUrl = getWeeklyRequirementReportDrilldownUrl;
		$timeout(function(){
			jQuery('#headingSupplyChainReports').addClass('selected');
			jQuery('#headingSupplyChainReports a').addClass('selected');
		}, 0);
		vm.scenarios = [];
		vm.scenarioCost = {};
		vm.scenarioMoq = {};
		vm.emptyCrossSite = true;
		vm.calculatePriceBreakAnalysis = calculatePriceBreakAnalysis;
		var defaultScenario = {
			'name': 'Cost Scenario ',
			'costTitle': 'Enter the price break unit cost given by Supplier for a specific Minimum Order Quantity (MOQ) for scenario ',
			'moqTitle': 'Price Break Quantity (MOQ) that will be required to achieve the unit price for scenario ',
			'moq': '',
			'daysCoverage': '',
			'daysCoverageDisplay': '',
			'materialCost': '',
			'orderingCost': '',
			'holdingCost': '',
			'totalCost': ''
		};


		function calculateValuesForCurrentScenarios(data) {
			var calculationMoqCurrent = data.minimumOrderQuantityFloat;
			var calculationOrderMultipleCurrent = data.orderMultipleFloat;
				
			if (calculationOrderMultipleCurrent > calculationMoqCurrent) {
				calculationMoqCurrent = calculationOrderMultipleCurrent;
			}
			vm.averageDailyDemand = numberFormatService.getOriginalNumber(vm.averageDailyDemandFormatted);
			var annualUsage = vm.averageDailyDemand * 5 * 52;
			var lowestTotalCostScenario = 'Current';
			var lowestTotalCost = 0;
			// ----------------------------- Calculate results for CURRENT Values ----------------------------------
			var materialCostCurrent = 0;
			var orderingCostCurrent = 0;
			var holdingCostCurrent = 0;
			var totalCostCurrent = 0;
				
			if (calculationMoqCurrent > annualUsage) {
				materialCostCurrent = calculationMoqCurrent * data.costPerItemFloat;
			} else {
				materialCostCurrent = annualUsage * data.costPerItemFloat;
			}
			vm.annualUsage = annualUsage;
			orderingCostCurrent = (annualUsage / calculationMoqCurrent) * vm.costToPlaceOrder;
			holdingCostCurrent = (calculationMoqCurrent / 2) * (vm.carryingCost/100) * data.costPerItemFloat;
			totalCostCurrent = materialCostCurrent + orderingCostCurrent + holdingCostCurrent;
			//Set this initially to the Current Scenario
			vm.lowestTotalCostScenario = 'Current';
			vm.lowestTotalCost = totalCostCurrent;
			vm.materialCostCurrent = materialCostCurrent;
			vm.orderingCostCurrent = orderingCostCurrent;
			vm.holdingCostCurrent = holdingCostCurrent;
			vm.totalCostCurrent = totalCostCurrent;	
			vm.daysCoverageCurrent = calculationMoqCurrent / vm.averageDailyDemand;
		}

		function calculateValuesForLeanDNAScenarios(data) {
			var materialCostLeandna = 0;
			var orderingCostLeandna = 0;
			var holdingCostLeandna = 0;
			var totalCostLeandna = 0;
			vm.averageDailyDemand = numberFormatService.getOriginalNumber(vm.averageDailyDemandFormatted);
			var calculationMoqLeandna = (2 * vm.annualUsage * vm.costToPlaceOrder) / (data.costPerItemFloat * (vm.carryingCost/100));
			calculationMoqLeandna = Math.sqrt(calculationMoqLeandna);
			calculationMoqLeandna = Math.ceil (calculationMoqLeandna);
				
			if (calculationMoqLeandna < 1) {
				calculationMoqLeandna = 1;
			}
				
			if (calculationMoqLeandna > vm.annualUsage) {
				materialCostLeandna = calculationMoqLeandna * data.costPerItemFloat;
			} else {
				materialCostLeandna = vm.annualUsage * data.costPerItemFloat;
			}

			orderingCostLeandna = (vm.annualUsage / calculationMoqLeandna) * vm.costToPlaceOrder;
			holdingCostLeandna = (calculationMoqLeandna / 2) * (vm.carryingCost/100) * data.costPerItemFloat;
			totalCostLeandna = materialCostLeandna + orderingCostLeandna + holdingCostLeandna;
			vm.daysCoverageLeandna = calculationMoqLeandna / vm.averageDailyDemand;

			//Check if LeanDNA is the Lowest Cost Scenario
			if (totalCostLeandna < vm.totalCostCurrent) {
				vm.lowestTotalCostScenario = 'LeanDNA';
				vm.lowestTotalCost = totalCostLeandna;
			}
			vm.calculationMoqLeandna = calculationMoqLeandna;
			vm.materialCostLeandna = materialCostLeandna;
			vm.orderingCostLeandna = orderingCostLeandna;
			vm.holdingCostLeandna = holdingCostLeandna;
			vm.totalCostLeandna = totalCostLeandna;	
		}
		function setDefaultScenarios() {
			var defaultScenarios = [];
			for (var i = 1; i <= 5; i++) {
				defaultScenarios.push({
					'name': 'Cost Scenario ',
					'costTitle': 'Enter the price break unit cost given by Supplier for a specific Minimum Order Quantity (MOQ) for scenario ',
					'moqTitle': 'Price Break Quantity (MOQ) that will be required to achieve the unit price for scenario ',
					'moq': '',
					'daysCoverage': '',
					'daysCoverageDisplay': '',
					'materialCost': '',
					'orderingCost': '',
					'holdingCost': '',
					'totalCost': ''
				});
			}
			vm.scenarios = defaultScenarios;
		}
			
		function calculateScenarios(scenarioIndex, unitPrice, moq, annualUsage, analysisAvgDailyDemandFloat) {
			var materialCost = 0;
			var orderingCost = 0;
			var holdingCost = 0;
			var totalCost = 0;
			var leandnaMoq = 0;
				
			if (moq > annualUsage) {
				materialCost = moq * unitPrice;
			} else {
				materialCost = annualUsage * unitPrice;
			}
			if (annualUsage / moq >= 1) {
				orderingCost = (annualUsage / moq) * vm.costToPlaceOrder;
			} else {
				orderingCost = Math.ceil(annualUsage / moq) * vm.costToPlaceOrder;
			}
			holdingCost = (moq / 2) * (vm.carryingCost/100) * unitPrice;
			totalCost = materialCost + orderingCost + holdingCost;
			leandnaMoq = (2 * annualUsage * vm.costToPlaceOrder) / (unitPrice * (vm.carryingCost/100));
			leandnaMoq = Math.sqrt (leandnaMoq);
			leandnaMoq = Math.ceil (leandnaMoq);	
				
			if (leandnaMoq < 1 ) {
				leandnaMoq = 1;
			}
				
			var daysCoverage = moq / analysisAvgDailyDemandFloat;
				
			//Check if Scneario 1 is the Lowest Cost Scenario
			if (totalCost < vm.lowestTotalCost) {
				vm.lowestTotalCostScenario = 'Scenario_' + scenarioIndex;
				vm.lowestTotalCost = totalCost;
			}
			vm.scenarios[scenarioIndex].moq = numberFormatService.getWithParameters(leandnaMoq, 0);
			vm.scenarios[scenarioIndex].daysCoverage = daysCoverage;
			vm.scenarios[scenarioIndex].daysCoverageDisplay = numberFormatService.getWithParameters(daysCoverage, 0);
			vm.scenarios[scenarioIndex].materialCost = currencyFormatService.getWithParameters(materialCost, 0);
			vm.scenarios[scenarioIndex].orderingCost = currencyFormatService.getWithParameters(orderingCost, 0);
			vm.scenarios[scenarioIndex].holdingCost = currencyFormatService.getWithParameters(holdingCost, 0);
			vm.scenarios[scenarioIndex].totalCost = currencyFormatService.getWithParameters(totalCost, 0);
		}
			
		function calculatePriceBreakAnalysis () {
			calculateValuesForCurrentScenarios(vm.data);
			calculateValuesForLeanDNAScenarios(vm.data);
			var updatedArray = [];
			for (var i = 0; i < 5; i++) {
				if (typeof vm.scenarioCost[i] !== 'undefined' && vm.scenarioCost[i].trim() != '' && vm.scenarioCost[i].trim() != '0' && typeof vm.scenarioMoq[i] !== 'undefined' && 
						vm.scenarioMoq[i].trim() != '' && vm.scenarioMoq[i].trim() != '0' ) {
					calculateScenarios(i, vm.scenarioCost[i].trim(), vm.scenarioMoq[i].trim(), vm.annualUsage, vm.averageDailyDemand);
				} else {
					vm.scenarios[i] = jQuery.extend({}, defaultScenario);
				}
				updatedArray[i] = jQuery.extend({}, vm.scenarios[i]);
			}
		}

		function fixQueryValue(queryVal) {
			return queryVal.replace(/[//]/g, '@@**');
		}
		
		function getWeeklyRequirementReportDrilldownUrl(data) {
			if (!data) return;
			return drilldownFunctionsService.getReportDrilldownUrl(
				'supply-chain/requirements/weekly-requirements/',
				null,
				{
					search: data.itemCode,
					factory: data.ldfNdx
				}
			);
		}

		function init() {
			var qParams = parseQueryString(window.location.href);
			if (globalConfig && globalConfig.factory && qParams.itemCode) {		
				$scope.itemCode = fixQueryValue(decodeURIComponent(qParams.itemCode));
				vm.currencySymbol = globalConfig.browser.currencySymbol;
				priceBreakAnalysisService.getPriceBreakAnalysis($scope.itemCode).then(function(data) {
					if (data && data.data.length > 0) {
						vm.data = data.data[0];
						vm.data.analysisVariabilityFloat = percentageFormatService.getWithParameters(vm.data.analysisVariabilityFloat*100, 2);
						vm.daysDisplayType = globalConfig.user.authFacts[globalConfig.factory.id].daysDisplayType;
						if (vm.daysDisplayType !== 'Calendar Days') {
							vm.data.leadTimeInDaysFloat = integerFormatService.getWithParameters(vm.data.leadTimeInDaysFloat * 5 / 7, 0);
							vm.data.orderPolicyValueDisplay = integerFormatService.getWithParameters(vm.data.orderPolicyValue * 5 / 7, 0) + ' ' + vm.daysDisplayType;
						} else {
							vm.data.orderPolicyValueDisplay = integerFormatService.getWithParameters(vm.data.orderPolicyValue, 0) + ' days';
						}
						vm.averageDailyDemand = numberFormatService.getWithParameters(vm.data.analysisAvgDailyDemandFloat, 2);
						vm.averageDailyDemandFormatted = numberFormatService.getWithParameters(vm.data.analysisAvgDailyDemandFloat, 2);
						vm.carryingCost = data.procurementCarryingCost;
						vm.costToPlaceOrder = data.costToPlaceOrder;
						vm.daysCoverageCurrent = numberFormatService.getWithParameters(vm.data.minimumOrderQuantityFloat / vm.data.analysisAvgDailyDemandFloat, 0);
						calculateValuesForCurrentScenarios(vm.data);
						calculateValuesForLeanDNAScenarios(vm.data);
						setDefaultScenarios();
					}
				}); 
				priceBreakAnalysisService.getCrossSitePriceBreakAnalysis($scope.itemCode).then(function(data) {
					if (data && data.length > 0) {
						vm.crossSites = data;
						angular.forEach(vm.crossSites, function(row) {
							if (row.daysDisplayType !== 'Calendar Days') {
								row.leadTimeInDaysFloatDisplay = integerFormatService.getWithParameters(row.leadTimeInDaysFloat / 7 * 5, 0) + ' Work Days';
							} else {
								row.leadTimeInDaysFloatDisplay = integerFormatService.getWithParameters(row.leadTimeInDaysFloat, 0);
							}
						});
						vm.emptyCrossSite = false;
					}
					else {
						vm.emptyCrossSite = true;
					}
				}); 
			} else {
				$timeout(function() {
					init();
				}, 10);
			}
		}
		init();
	}
	;
})();
